import { jsx, jsxs } from "react/jsx-runtime";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns/index.js";
import { DatePicker as DatePicker$1 } from "@mui/x-date-pickers/DatePicker/index.js";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker/index.js";
import { Language } from "../../../type/Translations.js";
import { enGB, de } from "date-fns/locale";
import { PickersActionBar } from "../pickers-action-bar/pickers-action-bar.js";
import { TextField } from "../../text-field/text-field.js";
import { theme } from "./theme/index.js";
import "@mui/material/Button/index.js";
import "@mui/material/styles";
import "@mui/x-date-pickers/internals/index.js";
import "../../../constants/create-theme/create-theme.js";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../pickers-action-bar/pickers-action-bar.styles.js";
import "react";
import "@mui/material/TextField/index.js";
import "../../text-field/text-field.styles.js";
import "../../../themes/date-calendar/date-calendar.js";
import "../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../themes/day-calendar/day-calendar.js";
import "../../../themes/filled-input/filled-input.js";
import "../../../themes/form-helper-text/form-helper-text.js";
import "../../../themes/form-label/form-label.js";
import "../../../themes/month-calendar/month-calendar.js";
import "../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../themes/pickers-day/pickers-day.js";
import "../../../themes/pickers-month/pickers-month.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../themes/pickers-year/pickers-year.js";
import "../../../themes/year-calendar/year-calendar.js";
const getLocale = (language) => {
  switch (language) {
    case Language.DEUTSCH: {
      return de;
    }
    default: {
      return enGB;
    }
  }
};
const DatePicker = ({
  slots,
  slotProps,
  monthsPerRow = 3,
  language = Language.DEUTSCH,
  labels,
  isStatic,
  open,
  ...rest
}) => {
  return /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsxs(LocalizationProvider, { adapterLocale: getLocale(language), dateAdapter: AdapterDateFns, localeText: labels, children: [
    !isStatic && /* @__PURE__ */ jsx(
      DatePicker$1,
      {
        monthsPerRow,
        slots: { textField: TextField, actionBar: PickersActionBar, ...slots },
        open,
        slotProps: {
          textField: { variant: "filled" },
          actionBar: { actions: ["cancel", "accept"] },
          ...slotProps
        },
        ...rest
      }
    ),
    isStatic && open && /* @__PURE__ */ jsx(
      StaticDatePicker,
      {
        monthsPerRow,
        slots: {
          textField: TextField,
          actionBar: PickersActionBar,
          toolbar: () => null,
          ...slots
        },
        slotProps: {
          textField: { variant: "filled" },
          actionBar: { actions: ["cancel", "accept"] },
          ...slotProps
        },
        ...rest
      }
    )
  ] }) });
};
export {
  DatePicker,
  getLocale
};
